import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/reports/lane-detail");

export const Route = createFileRoute("/reports/lane-detail")({
  head: () => ({
    meta: [
      { title: "Lane detail report — LevelLoad" },
      { name: "description", content: "Lane detail report — LevelLoad transport planning." },
      { property: "og:title", content: "Lane detail report — LevelLoad" },
      {
        property: "og:description",
        content: "Lane detail report — LevelLoad transport planning.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
